import axios from "axios";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import BrandList from "../Index/BrandList";

function DigitalShowroom() {
  let history = useHistory();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_API}/verify`, {
        headers: {
          "x-access-token": localStorage.getItem("authToken"),
        },
      })
      .then((res) => {
        console.log("result of verfication : ", res);
      })
      .catch((er) => {
        console.log("result of verfication error : ", er);
        history.push("/login");
      });
  }, []);

  return (
    <div>
      <BrandList isDsPage={true} />
    </div>
  );
}

export default DigitalShowroom;
